import type { FetchError } from 'ofetch'
import type { GiftCardOrderResponse } from '@/types/api/gift-cards'
import type { PersonaliseSubmitOrderParams, RecipientsSubmitOrderParams } from '../types/submit'

/**
 * @description Submits the form data to the backend API
 * @param payload {PersonaliseSubmitOrderParams | RecipientsSubmitOrderParams} Contains the step name and valid body data
 * @returns Contains details to progress to payment step and load Stripe widget
 */
export async function useSubmitForm(payload: PersonaliseSubmitOrderParams | RecipientsSubmitOrderParams) {
  try {
    return await $fetch<GiftCardOrderResponse>('/api/gift-cards/order', {
      method: 'POST',
      body: payload.body
    })
  } catch (error: unknown) {
    console.log(error as FetchError<GiftCardOrderResponse>)
  }
}
